import React, { useState } from "react";
import HeaderBar from "../../../Components/UI/headerbar";
import DataTable from "../../../Components/UI/table/DataTable";
import { useQuery } from "react-query";
import {
  deleteCategories,
  getCategories,
  updateCategories,
} from "../../../MyApi/product/categories";
import StatusBadge from "../../../Components/UI/statusBadge";
import TableActions from "../../../Components/UI/table/TableActions";
import Can from "../../../utils/can";
import i18next from "i18next";
import FilterBar from "../../../Components/UI/filterbar";
import StoreCategoryModal from "../../systemsettings/categories/storeModal";
import PaginationComponent from "../../../Components/UI/pagnationComponent";

const CategoriesPage = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [filters, setFilters] = useState({});
  const [modalMode, setModalMode] = useState("add");
  const [modalId, setModalId] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);

  const { data, refetch, isLoading, error, isFetching } = useQuery(
    ["getCategories", filters.store_id, filters.search, currentPage],
    () => getCategories("", "", filters.store_id, filters.search, currentPage),
  );
  const categories = data?.data?.categories || [];
  const totalItems = data?.data?.meta.total;
  const lastPage = data?.data?.meta.last_page;

  const categoryColumns = [
    {
      label: "اسم الفئة",
      render: (row) => (
        <div className="d-flex align-items-center gap-2">
          {row.icon !== null && <img src={row.icon} width={24} height={24} />}
          <div>
            <h6 className="font16">{row.name}</h6>
            <p>#{row.id}</p>
          </div>
        </div>
      ),
    },
    { label: "الاسم المستعار", accessor: "slug" },
    { label: "ترتيب الفئات ", accessor: "sort_order" },
    { label: "المتجر", render: (row) => row.store?.name || "___" },

    {
      label: "الحالة",
      render: (row) => (
        <StatusBadge status={row.is_active ? "active" : "inactive"} />
      ),
    },
    {
      label: "الإجراءات",
      render: (row) => (
        <TableActions
          edit={() => handleOpenModal("edit", row.id)}
          deleteFn={deleteCategories}
          id={row.id}
          refetch={refetch}
          mutationKey={"deleteCategories"}
          deletePermission={"delete_category"}
          editPermission={"update_category"}
          viewPermission={"view_category"}
          togglePermission={"update_category"}
          toggleMutationKey={"toggle-update-category"}
          queryKey={"getCategories"}
          toggleFn={(id, status) =>
            updateCategories(
              { is_active: status, _method: "PUT", lang: i18next.language },
              id,
            )
          }
          is_active={row.is_active}
        />
      ),
    },
  ];

  const handleOpenModal = (mode, id) => {
    setIsModalOpen(true);
    setModalMode(mode);
    setModalId(id);
  };
  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <div>
      <HeaderBar title={"فئات المتاجر"} content={"إدارة فئات المتاجر."} />

      <FilterBar
        placeholder={"ابحث بالاسم"}
        filtersConfig={{ store: true, search: "search" }}
        filters={filters}
        setFilters={setFilters}
      />

      {isModalOpen && (
        <StoreCategoryModal
          refetch={refetch}
          isOpen={isModalOpen}
          toggle={closeModal}
          modalMode={modalMode}
          modalId={modalId}
        />
      )}

      <Can permission={"view_category"}>
        <DataTable
          title={"الفئات"}
          columns={categoryColumns}
          data={categories}
          isLoading={isLoading}
          isFetching={isFetching}
          onAddClick={() => handleOpenModal("add")}
          actionLabel={"إضافة فئة جديدة "}
          createPermission={"create_category"}
          error={error}
          onRetry={() => refetch()}
        />
        <PaginationComponent
          totalItems={totalItems}
          itemsPerPage={lastPage}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
        />
      </Can>
    </div>
  );
};

export default CategoriesPage;
